import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import createReactContext from '../context';
import { Component } from '../component';
import { filterProps } from '../utils/objects';
import _validate from '../utils/validate';
import { wrapFormError, isSameError } from '../utils/errors';
import { ERROR_TYPE, FORCE_PASS, IGNORE_VALIDATE } from '../Datum/types';
import FieldError from './FieldError';

var _createReactContext = createReactContext(undefined),
    Provider = _createReactContext.Provider,
    Consumer = _createReactContext.Consumer;

function extendName() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = arguments.length > 1 ? arguments[1] : undefined;
  if (name === undefined) return undefined;
  if (name === '') return path;

  if (Array.isArray(name)) {
    return name.map(function (n) {
      return extendName(path, n);
    });
  }

  return "".concat(path).concat(path.length > 0 ? '.' : '').concat(name);
}

var FieldSet =
/*#__PURE__*/
function (_Component) {
  _inherits(FieldSet, _Component);

  var _super = _createSuper2(FieldSet);

  function FieldSet(props) {
    var _this;

    _classCallCheck(this, FieldSet);

    _this = _super.call(this, props);
    _this.updateTimer = void 0;
    _this.validate = _this.validate.bind(_assertThisInitialized(_this));
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FieldSet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(FieldSet.prototype), "componentDidMount", this).call(this);

      var _this$props = this.props,
          formDatum = _this$props.formDatum,
          name = _this$props.name,
          defaultValue = _this$props.defaultValue;
      formDatum.bind(name, this.handleUpdate, defaultValue, this.validate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(FieldSet.prototype), "componentWillUnmount", this).call(this);

      var _this$props2 = this.props,
          formDatum = _this$props2.formDatum,
          name = _this$props2.name;
      formDatum.unbind(name, this.handleUpdate);
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this2 = this;

      var _this$props3 = this.props,
          formDatum = _this$props3.formDatum,
          name = _this$props3.name;
      var value = formDatum.get(name);
      var data = formDatum.getValue();
      var validateProps = filterProps(this.props, function (v) {
        return typeof v === 'string' || typeof v === 'number';
      }); // @ts-ignore

      validateProps.type = 'array';

      var rules = _toConsumableArray(this.props.rules || []);

      rules = rules.concat(formDatum.getRule(name));
      if (rules.length === 0) return Promise.resolve(true);
      return _validate(value, data, rules, validateProps).then(function () {
        _this2.handleError();

        return true;
      }, function (e) {
        _this2.handleError(e);

        return wrapFormError(e);
      });
    }
  }, {
    key: "updateWithValidate",
    value: function updateWithValidate() {
      var _this3 = this;

      this.validate().then(function () {
        _this3.forceUpdate();
      });
    }
  }, {
    key: "handleError",
    value: function handleError(error) {
      var _this$props4 = this.props,
          formDatum = _this$props4.formDatum,
          name = _this$props4.name,
          onError = _this$props4.onError;
      if (isSameError(error, formDatum.getError(name, true))) return;
      formDatum.setError(name, error, true);
      if (onError) onError(error);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(_v, _n, type) {
      var _this4 = this;

      if (this.updateTimer) clearTimeout(this.updateTimer);
      this.updateTimer = setTimeout(function () {
        if (type === ERROR_TYPE || type === FORCE_PASS || type === IGNORE_VALIDATE) {
          _this4.forceUpdate();
        } else {
          _this4.updateWithValidate();
        }
      });
    }
  }, {
    key: "handleInsert",
    value: function handleInsert(index, value) {
      var _this$props5 = this.props,
          formDatum = _this$props5.formDatum,
          name = _this$props5.name;
      formDatum.insert(name, index, value);
      this.updateWithValidate();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(index) {
      var _this$props6 = this.props,
          formDatum = _this$props6.formDatum,
          name = _this$props6.name;
      formDatum.splice(name, index);
      this.updateWithValidate();
    }
  }, {
    key: "handleChange",
    value: function handleChange(index, value, update) {
      var _this$props7 = this.props,
          formDatum = _this$props7.formDatum,
          name = _this$props7.name;
      formDatum.set("".concat(name, "[").concat(index, "]"), value);
      if (update) this.updateWithValidate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props8 = this.props,
          children = _this$props8.children,
          formDatum = _this$props8.formDatum,
          name = _this$props8.name,
          empty = _this$props8.empty,
          defaultValue = _this$props8.defaultValue;
      var errors = formDatum.getError(name);
      var result = [];

      if (typeof children !== 'function') {
        return (
          /*#__PURE__*/
          React.createElement(Provider, {
            value: {
              path: name,
              val: this.validate
            }
          }, children, errors instanceof Error &&
          /*#__PURE__*/
          React.createElement(FieldError, {
            key: "error",
            error: errors
          }))
        );
      }

      var values = formDatum.get(name) || defaultValue || [];
      if (values && !Array.isArray(values)) values = [values];

      if (values.length === 0 && empty) {
        result.push(empty(this.handleInsert.bind(this, 0)));
      } else {
        var errorList = (Array.isArray(errors) ? errors : [errors]).filter(Boolean);
        values.forEach(function (v, i) {
          result.push(
          /*#__PURE__*/
          React.createElement(Provider, {
            key: i,
            value: {
              path: "".concat(name, "[").concat(i, "]"),
              val: _this5.validate
            }
          }, children({
            list: values,
            value: v,
            index: i,
            error: errorList,
            datum: formDatum,
            onChange: _this5.handleChange.bind(_this5, i),
            onInsert: _this5.handleInsert.bind(_this5, i),
            onAppend: _this5.handleInsert.bind(_this5, i + 1),
            onRemove: _this5.handleRemove.bind(_this5, i)
          })));
        });
      }

      if (errors instanceof Error) {
        result.push(
        /*#__PURE__*/
        React.createElement(FieldError, {
          key: "error",
          error: errors
        }));
      }

      return result;
    }
  }]);

  return FieldSet;
}(Component);

FieldSet.defaultProps = {
  rules: []
};
export var fieldSetConsumer = function fieldSetConsumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(Consumer, null, function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            path = _ref.path,
            val = _ref.val;

        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            name: extendName(path, props.name),
            innerFormNamePath: path,
            fieldSetValidate: val
          }))
        );
      })
    );
  };
};
export var FieldSetProvider = Provider;
export default fieldSetConsumer(FieldSet);